<template>
  <corner-ribbon class="bg-gray corner-ribbon">
    Reserved
  </corner-ribbon>
</template>

<script>
import CornerRibbon from "./CornerRibbon.vue";

export default {
  components: {
    CornerRibbon
  },
}
</script>
